import { softValidateResponse } from "@/server/validation";
import { AxiosRequestConfig } from "axios";
import { instance } from "../api-instance";
import {
  GetConsiderationStatusResponseSchema,
  SendToConsiderationResponseSchema,
  TranshInfoResponseSchema,
} from "./schemas";

export const ApplicationApi = {
  setAnonymousStep({
    id,
    step,
    isNew,
  }: {
    id: string;
    step: string;
    isNew: boolean;
  }): Promise<unknown> {
    return instance
      .post(`application/setRegistrationStep`, { id, step, isNew })
      .then((res) => res.data);
  },

  setLastStep({
    applicationId,
    step,
    isNew,
  }: {
    applicationId: string;
    step: string;
    isNew: boolean;
  }): Promise<unknown> {
    return instance
      .post(`application/setCurrentAppStep`, { applicationId, step, isNew })
      .then((res) => res.data);
  },

  deferredScansWorkflowStatus(
    {
      applicationId,
    }: {
      applicationId: string;
    },
    options: AxiosRequestConfig
  ): Promise<unknown> {
    return instance
      .get(`application/${applicationId}/DeferredScansWorkflowStatus`, options)
      .then((res) => res?.data);
  },

  resetDeferredScansWorkflow({
    applicationId,
  }: {
    applicationId: string;
  }): Promise<unknown> {
    return instance
      .post(`application/${applicationId}/ResetDeferredScansWorkflow`)
      .then((res) => res.data);
  },

  resetDeferredScansTimer(applicationId: string): Promise<unknown> {
    return instance
      .post(`application/${applicationId}/ResetDeferredScansTimer`)
      .then((res) => res.data);
  },

  transhInfo({ applicationId }: { applicationId: string }) {
    return instance
      .get(`application/${applicationId}/transhInfo`)
      .then(softValidateResponse(TranshInfoResponseSchema))
      .then((res) => res.data);
  },

  setClientDenial({
    applicationId,
    comment,
  }: {
    applicationId: string;
    comment: string;
  }): Promise<unknown> {
    return instance
      .post(`application/SetClientDenial`, { applicationId, comment })
      .then((res) => res.data);
  },

  sendToConsideration({
    applicationId,
    agreeItems,
    formPageId,
    documentRuleIds,
    sessionId,
    clientTime,
    clientTimeZone,
    cookie,
    revocationBKIAgreement,
  }: {
    applicationId: string;
    agreeItems: unknown;
    formPageId: string;
    documentRuleIds: unknown;
    sessionId: string;
    clientTime: string;
    clientTimeZone: string;
    cookie: string;
    revocationBKIAgreement?: boolean;
  }) {
    return instance
      .post(`/application/${applicationId}/SendToConsideration`, {
        agreeItems,
        formPageId,
        documentRuleIds,
        sessionId,
        clientTime,
        clientTimeZone,
        cookie,
        revocationBKIAgreement,
      })
      .then(softValidateResponse(SendToConsiderationResponseSchema))
      .then((res) => res.data);
  },

  getConsiderationStatus({
    applicationId,
    signal,
  }: {
    applicationId: string;
    signal?: AbortSignal;
  }) {
    return instance
      .get(`/application/${applicationId}/SendToConsiderationStatus`, {
        signal,
      })
      .then(softValidateResponse(GetConsiderationStatusResponseSchema))
      .then((res) => res.data);
  },

  smevValidation({
    applicationId,
  }: {
    applicationId: string;
  }): Promise<unknown> {
    return instance
      .post(`/application/${applicationId}/SmevValidation`)
      .then((res) => res.data);
  },
};
